export enum ResearchType {
  Survey = 1,
  AIInterview = 2,
  DiscussionForum = 3,
  FoodDiary = 4,
  ExternalSurvey = 5
}
